<template>
  <v-dialog
    :value="value"
    max-width="500"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card class="rounded-lg">
      <v-card-title class="d-flex align-center justify-space-between">
        <span>Choose how you'd like to withdraw</span>
        <v-btn icon small aria-label="Close" @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-4">
        <div
          class="cursor-pointer flex flex-row items-start justify-start gap-2 mb-4"
          @click="handleCaseSelected('snappy_exchange_username')"
        >
          <div>
            <v-icon>mdi-arrow-right</v-icon>
          </div>
          <div>
            <div class="font-semibold text-primary text-lg">Send to SnappyExchange username</div>
            <div>
              <div class="text-sm text-gray-500">
                Quick and easy - instantly transfer to another SnappyExchange
                user.
              </div>
            </div>
          </div>
        </div>
        <div
          class="cursor-pointer flex flex-row items-start justify-start gap-2"
          @click="handleCaseSelected('external_wallet')"
        >
          <div>
            <v-icon>mdi-arrow-left</v-icon>
          </div>
          <div>
            <div class="font-semibold text-primary text-lg">Withdraw to External Wallet</div>
            <div class="text-sm text-gray-500">
              Securely transfer to an external crypto wallet address.
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WithdrawCase',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedCase: 'snappy_exchange_username'
    }
  },
  methods: {
    handleCaseSelected(type) {
      this.selectedCase = type
      this.$emit('onCaseSelected', type)
    },
    closeModal() {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
/* Add any component-specific styles here if needed */
</style>
